import { db } from './idb';

export type VehicleDocType =
  | 'INSURANCE'
  | 'PUC'
  | 'FITNESS'
  | 'PERMIT'
  | 'ROAD_TAX'
  | 'REGISTRATION';

export type CachedVehicleDoc = {
  key: string;            // `${vehicleId}::${type}`
  vehicleId: string;
  type: VehicleDocType;
  mime: string;
  blob: Blob;
  cachedAt: number;
};

function keyOf(vehicleId: string, type: VehicleDocType): string {
  return `${vehicleId}::${type}`;
}

export async function getCachedVehicleDoc(
  vehicleId: string,
  type: VehicleDocType,
): Promise<CachedVehicleDoc | null> {
  const handle = await db();
  const row = await handle.get('vehicleComplianceDocs', keyOf(vehicleId, type));
  return row ?? null;
}

export async function putCachedVehicleDoc(
  vehicleId: string,
  type: VehicleDocType,
  mime: string,
  blob: Blob,
  cachedAt: number = Date.now(),
): Promise<void> {
  const handle = await db();
  await handle.put('vehicleComplianceDocs', {
    key: keyOf(vehicleId, type),
    vehicleId,
    type,
    mime,
    blob,
    cachedAt,
  });
}

export async function invalidateVehicleDoc(
  vehicleId: string,
  type: VehicleDocType,
): Promise<void> {
  const handle = await db();
  await handle.delete('vehicleComplianceDocs', keyOf(vehicleId, type));
}

export async function invalidateAllVehicleDocs(): Promise<void> {
  const handle = await db();
  await handle.clear('vehicleComplianceDocs');
}
